import { initBotId } from 'botid/client/core';

// Guest-facing POST endpoints that send email or write rows without a
// session (#178). Each route also calls checkBotId() server-side. Vercel-only
// (#199): off Vercel the challenge endpoints don't exist.
if (process.env.NEXT_PUBLIC_ON_VERCEL) {
  initBotId({
    protect: [
      { path: '/api/staging-requests', method: 'POST' },
      { path: '/api/contact', method: 'POST' },
      { path: '/api/newsletter', method: 'POST' },
      { path: '/api/testimonials', method: 'POST' },
      { path: '/api/reviews/private-feedback', method: 'POST' },
    ],
  });
}
